var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingPageSolutions2New(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Landing-page-solutions-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing-page-solutions-2",
    clipPath: "url(#clip-Landing-page-solutions-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Contact_us-amico",
    "data-name": "Contact us-amico",
    transform: "translate(140.05 105.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-41",
    transform: "translate(52.95 443.075)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 346.613,
    cy: 196.904,
    rx: 346.613,
    ry: 196.904,
    transform: "translate(0 0)",
    fill: "#e8e7e7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-41",
    transform: "translate(94.252 563.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8305",
    "data-name": "Path 8305",
    d: "M446.869,532.189,188.144,382.8a14.953,14.953,0,0,1,0-25.91l25.522-16.095a29.024,29.024,0,0,1,28.97,0L501.4,490.2a14.952,14.952,0,0,1,0,25.91l-25.522,16.078a28.954,28.954,0,0,1-29.012,0Z",
    transform: "translate(2.681 -331.504)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 56.147,
    cy: 32.243,
    rx: 56.147,
    ry: 32.243,
    transform: "translate(0 0)",
    fill: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-41",
    transform: "translate(625.701 500.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8306",
    "data-name": "Path 8306",
    d: "M388.41,432.908l24.627,14.161s-12.577-39.526-5.875-79.366a76.687,76.687,0,0,1,9.87-26.554c1.9-4.028,16.623-28.918,3.525-40.318s-43.589,11.515-41.934,72.847a237.881,237.881,0,0,0,9.8,59.218Z",
    transform: "translate(-378.558 -298.009)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8307",
    "data-name": "Path 8307",
    d: "M388.41,432.908l24.627,14.161s-12.577-39.526-5.875-79.366a76.687,76.687,0,0,1,9.87-26.554c1.9-4.028,16.623-28.918,3.525-40.318s-43.589,11.515-41.934,72.847a237.881,237.881,0,0,0,9.8,59.218Z",
    transform: "translate(-378.558 -298.009)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8308",
    "data-name": "Path 8308",
    d: "M395,435.975a.862.862,0,0,1-.827-.564c-.087-.263-9.5-25.981-9.2-67.318S407,304.312,407.208,304.1a.884.884,0,1,1,1.248,1.248c-.212.211-21.424,21.988-21.723,62.761s8.988,66.456,9.094,66.7a.879.879,0,0,1-.529,1.126.828.828,0,0,1-.3.038Z",
    transform: "translate(-373.697 -293.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8309",
    "data-name": "Path 8309",
    d: "M394.4,419.983l33.667,19.349a16.2,16.2,0,0,0,21.495-4.627,17.59,17.59,0,0,0,2.655-11.7c-1.619-17.486-9.216-21.513.087-29.306s11.733-8.337,11.2-15.831-5.64-10.765-8.074-13.721-9.146-9.146-4.573-18.294,10.81-18,1.354-22.04c-5.64-2.427-15.058.808-21.248,7.52s-11.294,11.557-17.22,13.176-18.275,1.88-17.749,12.1,3.236,13.721.808,18.275C392.239,383.414,372.344,388.25,394.4,419.983Z",
    transform: "translate(-374.277 -279.036)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8310",
    "data-name": "Path 8310",
    d: "M399.923,428.14a.914.914,0,0,1-.879-.808c0-.6-5.17-60.966,36.341-101.143a.879.879,0,0,1,1.213,1.266c-40.914,39.6-35.848,99.12-35.8,99.719a.879.879,0,0,1-.792.94Z",
    transform: "translate(-363.169 -276.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8311",
    "data-name": "Path 8311",
    d: "M409.279,365.981a.879.879,0,0,1-.879-.808,34.544,34.544,0,0,0-12.718-24.15.879.879,0,0,1-.211-1.231.862.862,0,0,1,1.213-.212,35.831,35.831,0,0,1,13.474,25.487.9.9,0,0,1-.808.968Z",
    transform: "translate(-365.847 -266.582)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8312",
    "data-name": "Path 8312",
    d: "M402,365.114a.879.879,0,0,1-.581-.211.9.9,0,0,1-.087-1.248c.423-.493,10.81-11.961,35.181-8.93a.879.879,0,0,1,.757.985.9.9,0,0,1-.985.773c-23.4-2.937-33.545,8.225-33.651,8.321a.9.9,0,0,1-.634.3Z",
    transform: "translate(-361.436 -255.352)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-41",
    transform: "translate(279.292 31.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8313",
    "data-name": "Path 8313",
    d: "M438.257,739.672,210.7,608.291c-16.059-9.27-29.076-34.142-29.076-55.55V65.5c0-21.408,13.016-31.24,29.076-21.969L438.257,174.907c16.059,9.27,29.075,34.142,29.075,55.55V717.7C467.332,739.092,454.316,748.943,438.257,739.672Z",
    transform: "translate(-181.627 -24.728)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8314",
    "data-name": "Path 8314",
    d: "M460.206,166.192,232.64,34.81c-6.859-3.957-13.16-4.415-18.134-1.988h0a14.864,14.864,0,0,0-1.76,1.039L187.24,48.689c5.137-3.078,11.855-2.85,19.227,1.41L434.012,181.48c16.059,9.27,29.076,34.142,29.076,55.55V724.271c0,11.329-3.642,19.349-9.447,23.149l25.172-14.652h0c6.42-3.412,10.553-11.768,10.553-23.746V221.774C489.369,200.334,476.263,175.46,460.206,166.192Z",
    transform: "translate(-177.366 -31.334)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8315",
    "data-name": "Path 8315",
    d: "M348.127,154.851V642.1c0,11.329-3.64,19.349-9.447,23.149l25.189-14.652h0c6.42-3.412,10.553-11.768,10.553-23.746V139.6l-26.209,15.216Z",
    transform: "translate(-62.422 50.843)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8316",
    "data-name": "Path 8316",
    d: "M370.256,161.09l-26.209,15.126v11.82l26.209-15.145Z",
    transform: "translate(-58.349 67.154)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8317",
    "data-name": "Path 8317",
    d: "M354.244,221.854h0c-2.35,1.354-4.23-.087-4.23-3.2V193.234a10.166,10.166,0,0,1,4.23-8.11h0c2.35-1.354,4.23,0,4.23,3.2v25.41a10.168,10.168,0,0,1-4.23,8.119Z",
    transform: "translate(-53.817 85.002)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8318",
    "data-name": "Path 8318",
    d: "M351.425,219.425V193.937a10.166,10.166,0,0,1,4.23-8.11,2.71,2.71,0,0,1,2.674-.235h0l-3.184-1.645h0a2.745,2.745,0,0,0-2.745.211,10.2,10.2,0,0,0-4.256,8.11v25.4a3.816,3.816,0,0,0,1.443,3.4h0l3.325,1.76h0a3.659,3.659,0,0,1-1.488-3.4Z",
    transform: "translate(-55.253 84.299)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8319",
    "data-name": "Path 8319",
    d: "M354.244,256.824h0c-2.35,1.354-4.23,0-4.23-3.2V228.2a10.184,10.184,0,0,1,4.23-8.109h0c2.35-1.354,4.23,0,4.23,3.219v25.4A10.133,10.133,0,0,1,354.244,256.824Z",
    transform: "translate(-53.817 111.543)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8320",
    "data-name": "Path 8320",
    d: "M351.426,254.33V228.911a10.185,10.185,0,0,1,4.23-8.11,2.761,2.761,0,0,1,2.674-.235h0l-3.184-1.645h0a2.655,2.655,0,0,0-2.745.211,10.149,10.149,0,0,0-4.256,8.109v25.471a3.8,3.8,0,0,0,1.443,3.4h0l3.325,1.76h0A3.64,3.64,0,0,1,351.426,254.33Z",
    transform: "translate(-55.254 110.837)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8321",
    "data-name": "Path 8321",
    d: "M423.478,180.561,199.872,51.415a6.173,6.173,0,0,0-9.252,5.278V544.73c0,16.287,11.557,36.287,25.663,44.432l218.117,126a6.815,6.815,0,0,0,10.2-5.894V217.2C444.691,203.764,435.157,187.282,423.478,180.561Z",
    transform: "translate(-174.8 -16.714)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8322",
    "data-name": "Path 8322",
    d: "M423.478,180.561,199.872,51.415a6.173,6.173,0,0,0-9.252,5.278V544.73c0,16.287,11.557,36.287,25.663,44.432l218.117,126a6.815,6.815,0,0,0,10.2-5.894V217.2C444.691,203.764,435.157,187.282,423.478,180.561Z",
    transform: "translate(-174.8 -16.714)",
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8323",
    "data-name": "Path 8323",
    d: "M233.9,70.23l3.466,14.581,74.126,42.745,12.8-6.815Z",
    transform: "translate(-141.95 -1.809)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8324",
    "data-name": "Path 8324",
    d: "M249.546,81.3c0,2.427-1.76,3.4-3.8,2.2A8.408,8.408,0,0,1,242,76.916c0-2.411,1.76-3.4,3.8-2.181A8.373,8.373,0,0,1,249.546,81.3Z",
    transform: "translate(-135.803 1.215)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8325",
    "data-name": "Path 8325",
    d: "M292.014,106.934a2.481,2.481,0,0,1-1.161-.3L253,85.528a2.376,2.376,0,0,1,2.305-4.152l37.871,21.093a2.376,2.376,0,0,1-1.161,4.451Z",
    transform: "translate(-128.331 6.453)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8326",
    "data-name": "Path 8326",
    d: "M221.813,112.17c-2.305-1.337-3.976-.176-3.976,2.761a8.93,8.93,0,0,0,3.976,7.423,4.185,4.185,0,0,0,4.345,0L229.833,129a7.968,7.968,0,0,1-8.356-.4,21.3,21.3,0,0,1-10.168-17.309c0-6.526,4.38-8.8,10.412-5.278a23.816,23.816,0,0,1,8.11,8.8l-3.675,2.921a12.965,12.965,0,0,0-4.345-5.558Z",
    transform: "translate(-159.096 24.096)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8327",
    "data-name": "Path 8327",
    d: "M242.977,129.636c0,6.58-4.451,8.8-10.553,5.278a21.723,21.723,0,0,1-10.553-17.589c0-6.58,4.451-8.8,10.553-5.278A21.6,21.6,0,0,1,242.977,129.636ZM228.4,121.245a9.533,9.533,0,0,0,4.117,7.651c2.181,1.267,3.941,0,3.941-2.991a9.2,9.2,0,0,0-3.941-7.52C230.3,117.111,228.4,118.2,228.4,121.245Z",
    transform: "translate(-151.081 28.67)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8328",
    "data-name": "Path 8328",
    d: "M240.178,118.68l7.6,15.831v-11.4l5.753,3.325v22.181l-5.278-3.055-7.564-15.69v11.315l-5.788-3.342V115.62Z",
    transform: "translate(-141.19 32.642)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8329",
    "data-name": "Path 8329",
    d: "M263.637,132.213v5.8l-5.487-3.165v16.393L251.8,147.57V131.177l-5.452-3.149V122.24Z",
    transform: "translate(-132.495 37.666)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8330",
    "data-name": "Path 8330",
    d: "M269.566,152.674l-7.212-4.169-.985,2.568-6.509-3.76,8.11-17.5,6.526,3.76,7.811,26.7-6.772-3.906ZM268,146.518l-1.969-7.581-2.023,5.278Z",
    transform: "translate(-126.04 43.416)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8331",
    "data-name": "Path 8331",
    d: "M277.883,144.538c-2.305-1.318-3.976-.176-3.976,2.78a8.953,8.953,0,0,0,3.976,7.423,4.258,4.258,0,0,0,4.361,0l3.675,6.648a8.074,8.074,0,0,1-8.373-.4,21.3,21.3,0,0,1-10.168-17.326c0-6.526,4.4-8.8,10.412-5.278a24.2,24.2,0,0,1,8.126,8.8l-3.675,2.9A13.245,13.245,0,0,0,277.883,144.538Z",
    transform: "translate(-116.54 48.666)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8332",
    "data-name": "Path 8332",
    d: "M295.237,150.448v5.783l-5.487-3.165v16.449L283.4,165.84V149.447l-5.452-3.149V140.51Z",
    transform: "translate(-108.51 51.533)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8333",
    "data-name": "Path 8333",
    d: "M302.472,171.037c1.565.9,2.761.193,2.761-2V156.244L311.6,159.9v12.788c0,5.894-3.525,7.651-9.146,4.432a18.118,18.118,0,0,1-9.306-15.075V149.26l6.368,3.675v12.788a6.526,6.526,0,0,0,2.956,5.313Z",
    transform: "translate(-96.979 58.175)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8334",
    "data-name": "Path 8334",
    d: "M313.325,164.66c-.721-.4-1.175-.423-1.175.235,0,2.78,9.938,6.789,9.938,14.828,0,4.935-3.746,4.935-8.074,2.444a32.136,32.136,0,0,1-9.623-9.094l2.35-4.152a28.286,28.286,0,0,0,7.318,7.67c.94.545,1.53.545,1.53-.235,0-2.886-9.957-6.718-9.957-14.511,0-4.432,3.236-5.278,8.225-2.463a30.642,30.642,0,0,1,8.356,7.44l-2.291,4.258a34.627,34.627,0,0,0-6.6-6.42Z",
    transform: "translate(-88.446 64.622)",
    fill: "#337acc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-41",
    transform: "translate(229.779 203.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8335",
    "data-name": "Path 8335",
    d: "M233.71,202.749A45.189,45.189,0,1,0,221.855,213l22.023,9.569Z",
    transform: "translate(-153.477 -129.029)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8336",
    "data-name": "Path 8336",
    d: "M233.71,202.749A45.189,45.189,0,1,0,221.855,213l22.023,9.569Z",
    transform: "translate(-153.477 -129.029)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8337",
    "data-name": "Path 8337",
    d: "M173.727,156.152c0-.686-.493-1.074-1.389-1.074a10.062,10.062,0,0,0-5.558,2.62l-2.5-4.86a15.979,15.979,0,0,1,9.094-3.2c4.23,0,7.423,2.216,7.423,5.522a10.932,10.932,0,0,1-4.011,6.895l-3.149,3.114h7.44v5.17H165.1v-4.23l7.125-7.369a4.8,4.8,0,0,0,1.513-2.585Z",
    transform: "translate(-145.278 -113.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8338",
    "data-name": "Path 8338",
    d: "M186.223,149.81l-4.855,11.644h1.988v-3.913h6.11v3.922h2.322v4.8h-2.322v3.957h-6.11v-3.957H174.65v-4.361l5.278-12.083Z",
    transform: "translate(-137.406 -113.254)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8339",
    "data-name": "Path 8339",
    d: "M202.5,160.566v10.149h-6.545v-8.267a1.9,1.9,0,0,0-1.88-2.164c-1.283,0-2.094,1-2.094,2.55v7.879H185.44V149.15h6.545v7.933a5.71,5.71,0,0,1,10.518,3.483Z",
    transform: "translate(-129.218 -113.755)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-41",
    transform: "translate(254.123 273.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8340",
    "data-name": "Path 8340",
    d: "M395.559,301.563V520.119a14.071,14.071,0,0,1-21.109,12.208L256.738,464.358l-20.863-12.032A47.4,47.4,0,0,1,212.2,411.4V192.821a14.071,14.071,0,0,1,21.107-12.208l138.61,80.017A47.264,47.264,0,0,1,395.559,301.563Z",
    transform: "translate(-133.251 -161.167)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8341",
    "data-name": "Path 8341",
    d: "M395.559,301.563V520.119a14.071,14.071,0,0,1-21.109,12.208L256.738,464.358l-20.863-12.032A47.4,47.4,0,0,1,212.2,411.4V192.821a14.071,14.071,0,0,1,21.107-12.208l138.61,80.017A47.264,47.264,0,0,1,395.559,301.563Z",
    transform: "translate(-133.251 -161.167)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8342",
    "data-name": "Path 8342",
    d: "M308.554,322.08s22.04,36.553,6.11,77.766L237.49,355.555Z",
    transform: "translate(-114.055 -52.361)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 24.714,
    cy: 24.714,
    r: 24.714,
    transform: "translate(177.57 123.985) rotate(-82.98)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8343",
    "data-name": "Path 8343",
    d: "M284,192.536s7.581-12.314,9.9-11.416-1.513,12.631-1.513,12.631,11.468,2.392,9.341,5.278-16.149,2.2-16.149,2.2Z",
    transform: "translate(-78.755 -159.385)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8344",
    "data-name": "Path 8344",
    d: "M337.083,232.181c-5.278,39.648-38.7,39.648-38.7,39.648l-70.009-30.817s-5.278-4.627-6.895-15.251a46.456,46.456,0,0,1,0-13.122v-.122c2.235-16.684,14.706-34.6,41.864-40.106a88.991,88.991,0,0,1,18.094-1.76,82.394,82.394,0,0,1,8.8.439c21.107,2.075,35.9,11.926,42.954,27.247a49.255,49.255,0,0,1,3.525,10.81A68.282,68.282,0,0,1,337.083,232.181Z",
    transform: "translate(-126.561 -167.297)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8345",
    "data-name": "Path 8345",
    d: "M206.3,249.231s-24.855-.862-34.424,23.361a24.7,24.7,0,0,0,24.4,0C210.12,265.469,206.3,249.231,206.3,249.231Z",
    transform: "translate(-163.854 -107.655)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8346",
    "data-name": "Path 8346",
    d: "M206.3,249.231s-24.855-.862-34.424,23.361a24.7,24.7,0,0,0,24.4,0C210.12,265.469,206.3,249.231,206.3,249.231Z",
    transform: "translate(-163.854 -107.655)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8347",
    "data-name": "Path 8347",
    d: "M209.062,272.164s-7.036-30.572-10.749-30.941-4.432,9.322-4.134,14.8l-8.8-18.926a4.768,4.768,0,0,0-6.613-2.129c-8.8,4.836-24.221,19.542,8.3,55.9Z",
    transform: "translate(-167.318 -118.925)",
    fill: "#945959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8348",
    "data-name": "Path 8348",
    d: "M295.7,244.245l-5.278-.686a30.22,30.22,0,0,0-28.145,11.82l-31.4,41.793-24.627-43.448s-2.956,29.55-34.424,23.361l33.789,56.868a26,26,0,0,0,42.533,3.114l28.918-35.549Z",
    transform: "translate(-163.895 -112.16)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8349",
    "data-name": "Path 8349",
    d: "M328.626,342.227c-7.036,17.836-7.811,21.318-3.525,30.236a114.107,114.107,0,0,1,7.036,20.475s-32.612,36.553-79.032,22.867l-20.863-12.032a46.719,46.719,0,0,1-11.573-9.428l6.345-47.353a16.535,16.535,0,0,0-.738-7.4l-6.667-19.542a53.4,53.4,0,0,1,13.228-55.427l22.409-21.9,58.856,7.52,8.8,2.514a24.89,24.89,0,0,1,17.73,27.388C337.755,300.909,333.041,331.03,328.626,342.227Z",
    transform: "translate(-129.801 -112.595)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8350",
    "data-name": "Path 8350",
    d: "M328.626,342.227c-7.036,17.836-7.811,21.318-3.525,30.236a114.107,114.107,0,0,1,7.036,20.475s-32.612,36.553-79.032,22.867l-20.863-12.032a46.719,46.719,0,0,1-11.573-9.428l6.345-47.353a16.535,16.535,0,0,0-.738-7.4l-6.667-19.542a53.4,53.4,0,0,1,13.228-55.427l22.409-21.9,58.856,7.52,8.8,2.514a24.89,24.89,0,0,1,17.73,27.388C337.755,300.909,333.041,331.03,328.626,342.227Z",
    transform: "translate(-129.801 -112.595)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8351",
    "data-name": "Path 8351",
    d: "M283.964,293.905l-11.785-10.044a9.447,9.447,0,0,0-9.2-1.76l-14.248,4.907-1.918-7.99a9.463,9.463,0,0,0-11.82-6.878l-6.173,1.76,10.448-20.017a37.483,37.483,0,0,1,15.11-15.444l4.1-2.251,33.86,1.76s12.612,5.278,12.612,17.154l-20.985,38.7",
    transform: "translate(-120.635 -117.553)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8352",
    "data-name": "Path 8352",
    d: "M279.659,270.654,245.71,297.11V212.87h33.949Z",
    transform: "translate(-107.816 -135.251)",
    fill: "#945959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8353",
    "data-name": "Path 8353",
    d: "M250.466,241.77,240.14,282.842l43.614-34.123Z",
    transform: "translate(-112.045 -113.316)",
    fill: "#945959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8354",
    "data-name": "Path 8354",
    d: "M245.716,257.6a59.42,59.42,0,0,0,33.93-32.295V212.87H245.7Z",
    transform: "translate(-107.825 -135.251)",
    fill: "#703838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8355",
    "data-name": "Path 8355",
    d: "M269.077,177.38c-12.875,0-40.247,7.177-43.412,40.889s-.106,59.805,17.274,62.339,57.766-10.079,63.185-53.7S281.618,177.38,269.077,177.38Z",
    transform: "translate(-123.865 -162.189)",
    fill: "#945959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8356",
    "data-name": "Path 8356",
    d: "M243.374,208.73v19.859l-11.644-3.572Z",
    transform: "translate(-118.428 -138.394)",
    fill: "#703838"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 4.047,
    cy: 4.047,
    r: 4.047,
    transform: "translate(133.847 69.72)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8357",
    "data-name": "Path 8357",
    d: "M236.362,210.836a4.047,4.047,0,1,1-1.175-2.872,4.047,4.047,0,0,1,1.175,2.872Z",
    transform: "translate(-121.056 -139.882)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8358",
    "data-name": "Path 8358",
    d: "M227.869,207.114l7.914-4.7s-3.027-3.149-6.051-1.267A5.536,5.536,0,0,0,227.869,207.114Z",
    transform: "translate(-121.548 -144.606)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8359",
    "data-name": "Path 8359",
    d: "M235.24,225.861a17.154,17.154,0,0,0,10.887-2.921s.757,5.753-4.063,6.843a6.211,6.211,0,0,1-6.824-3.922Z",
    transform: "translate(-115.765 -127.608)",
    fill: "#703838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8360",
    "data-name": "Path 8360",
    d: "M231.31,191.528s4.838,46.528,68.11,47.985c0,0,19.121-46.244-18.663-61.267S231.31,191.528,231.31,191.528Z",
    transform: "translate(-118.746 -164.867)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8361",
    "data-name": "Path 8361",
    d: "M295.976,209.65h0l-7.776-4.5h0c-2.956-1.76-7.036-1.513-11.557,1.09a35.916,35.916,0,0,0-16.254,28.145c0,5.189,1.76,8.8,4.784,10.553h0l7.635,4.4.439.235.263.157h0c2.886,1.41,6.737,1.074,10.976-1.372a36.081,36.081,0,0,0,16.254-28.145C300.69,214.98,298.878,211.357,295.976,209.65Z",
    transform: "translate(-96.677 -141.97)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 22.973,
    cy: 13.263,
    rx: 22.973,
    ry: 13.263,
    transform: "translate(164.782 100.805) rotate(-60)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 22.973,
    cy: 13.263,
    rx: 22.973,
    ry: 13.263,
    transform: "translate(164.782 100.805) rotate(-60)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8362",
    "data-name": "Path 8362",
    d: "M292.9,214.419h0l-5.278-3.078h0a7.769,7.769,0,0,0-7.9.738A24.627,24.627,0,0,0,268.6,231.347a7.82,7.82,0,0,0,3.271,7.2h0l5.278,3.008a1.772,1.772,0,0,0,.3.176l.176.106h0a8.091,8.091,0,0,0,7.52-.94,24.627,24.627,0,0,0,11.117-19.243,8.189,8.189,0,0,0-3.367-7.231Z",
    transform: "translate(-90.483 -136.976)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8363",
    "data-name": "Path 8363",
    d: "M293.831,220.278a24.625,24.625,0,0,1-11.117,19.243c-6.157,3.525-11.134.667-11.134-6.42a24.521,24.521,0,0,1,11.134-19.243C288.854,210.3,293.831,213.172,293.831,220.278Z",
    transform: "translate(-88.182 -135.659)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8364",
    "data-name": "Path 8364",
    d: "M293.831,220.278a24.625,24.625,0,0,1-11.117,19.243c-6.157,3.525-11.134.667-11.134-6.42a24.521,24.521,0,0,1,11.134-19.243C288.854,210.3,293.831,213.172,293.831,220.278Z",
    transform: "translate(-88.182 -135.659)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8365",
    "data-name": "Path 8365",
    d: "M283.448,174.86a29.268,29.268,0,0,0-17.589-6.11h-1.565a94.783,94.783,0,0,0-19.227,1.76h0v3.271h3.271a43.473,43.473,0,0,1,42,43.5v13.843a3.906,3.906,0,0,0,4.31,3.887h.4l3.525-1.09h0a3.273,3.273,0,0,1-.721.141,4.31,4.31,0,0,0,3.729-4.361v-12.84C301.543,193.629,291.494,181.139,283.448,174.86Z",
    transform: "translate(-108.306 -168.745)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8366",
    "data-name": "Path 8366",
    d: "M261.226,242.5a10.1,10.1,0,0,1-4.2-.914L246.029,236.5a1.318,1.318,0,1,1,1.09-2.392l10.993,5.083a7.423,7.423,0,0,0,8.479-1.584L277.145,226.7a1.318,1.318,0,0,1,1.863,0,1.337,1.337,0,0,1,0,1.864l-10.553,10.906a10.009,10.009,0,0,1-7.228,3.027Z",
    transform: "translate(-108.229 -125.046)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8367",
    "data-name": "Path 8367",
    d: "M261.226,242.5a10.1,10.1,0,0,1-4.2-.914L246.029,236.5a1.318,1.318,0,1,1,1.09-2.392l10.993,5.083a7.423,7.423,0,0,0,8.479-1.584L277.145,226.7a1.318,1.318,0,0,1,1.863,0,1.337,1.337,0,0,1,0,1.864l-10.553,10.906a10.009,10.009,0,0,1-7.228,3.027Z",
    transform: "translate(-108.229 -125.046)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8368",
    "data-name": "Path 8368",
    d: "M251.733,232.217a5.137,5.137,0,1,1-5.137-5.137,5.137,5.137,0,0,1,5.137,5.137Z",
    transform: "translate(-111.045 -124.465)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8369",
    "data-name": "Path 8369",
    d: "M251.733,232.217a5.137,5.137,0,1,1-5.137-5.137,5.137,5.137,0,0,1,5.137,5.137Z",
    transform: "translate(-111.045 -124.465)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8370",
    "data-name": "Path 8370",
    d: "M301.526,216.827v12.849a4.31,4.31,0,0,1-3.729,4.361,4.152,4.152,0,0,1-4.592-4.133v-13.07a46.244,46.244,0,0,0-48.126-46.279,94.793,94.793,0,0,1,19.227-1.76h1.53a29.271,29.271,0,0,1,17.589,6.11C291.485,181.1,301.526,193.591,301.526,216.827Z",
    transform: "translate(-108.297 -168.707)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8371",
    "data-name": "Path 8371",
    d: "M301.526,216.827v12.849a4.31,4.31,0,0,1-3.729,4.361,4.152,4.152,0,0,1-4.592-4.133v-13.07a46.244,46.244,0,0,0-48.126-46.279,94.793,94.793,0,0,1,19.227-1.76h1.53a29.271,29.271,0,0,1,17.589,6.11C291.485,181.1,301.526,193.591,301.526,216.827Z",
    transform: "translate(-108.297 -168.707)",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8372",
    "data-name": "Path 8372",
    d: "M266.4,334.03s-8.514,23.448,21.918,34c0,0,9.938-14.6,0-26.554S266.4,334.03,266.4,334.03Z",
    transform: "translate(-92.943 -43.923)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8373",
    "data-name": "Path 8373",
    d: "M266.4,334.03s-8.514,23.448,21.918,34c0,0,9.938-14.6,0-26.554S266.4,334.03,266.4,334.03Z",
    transform: "translate(-92.943 -43.923)",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8374",
    "data-name": "Path 8374",
    d: "M286.023,334.28s-29.726,10.887-29.569,15.11,12.631,1.337,12.631,1.337l-4.556,2.992A27.862,27.862,0,0,0,253.886,366.7h0a5.137,5.137,0,0,0,2.35,6.42l11.294,5.98a5.4,5.4,0,0,0,7.369-2.376h0a10.553,10.553,0,0,1,6.173-5.278,34.039,34.039,0,0,0,22.181-23.993Z",
    transform: "translate(-101.885 -43.101)",
    fill: "#945959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8375",
    "data-name": "Path 8375",
    d: "M285.526,248.41s-15.831,8.8-7.423,35.5,24.181,68.126,24.181,68.126l-36.353,46.35A27.827,27.827,0,0,1,285.4,410.063a24.627,24.627,0,0,1,2.444,22.324l45.137-58.045a40.888,40.888,0,0,0,6.4-38.4l-19.349-56.5a47.283,47.283,0,0,0-29.9-29.569Z",
    transform: "translate(-92.47 -108.277)",
    fill: "#337acc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icons--inject-41",
    transform: "translate(85.581 75.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8376",
    "data-name": "Path 8376",
    d: "M165.875,176.649l-69.95-40.456a5.894,5.894,0,0,0-5.576-.616h0a3.379,3.379,0,0,0-.545.317l-15.216,8.93h.106a7.889,7.889,0,0,0-3.13,7.247v77.818c0,6.58,3.995,14.231,8.93,17.079l69.95,40.447a5.593,5.593,0,0,0,6.157.263.317.317,0,0,0-.122.087l15.11-8.8h0c1.969-1.055,3.219-3.624,3.219-7.3v-77.94C174.81,187.151,170.888,179.5,165.875,176.649Z",
    transform: "translate(-71.505 3.36)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8377",
    "data-name": "Path 8377",
    d: "M170.981,184.021a17.8,17.8,0,0,0-6.439-7.369L94.587,136.193a5.894,5.894,0,0,0-5.576-.616h0a3.383,3.383,0,0,0-.545.317l-15.216,8.93a5.7,5.7,0,0,1,5.91.439l69.955,40.456a18.118,18.118,0,0,1,6.6,7.705h0Z",
    transform: "translate(-70.174 3.36)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8378",
    "data-name": "Path 8378",
    d: "M122.712,259.481a7.823,7.823,0,0,1-2.9,7.036l15.11-8.8h0c1.969-1.055,3.219-3.624,3.219-7.3V172.64a22,22,0,0,0-2.5-9.71l-15.274,9.4h0a21.969,21.969,0,0,1,2.35,9.376Z",
    transform: "translate(-34.833 24.45)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8379",
    "data-name": "Path 8379",
    d: "M170.981,184.021a17.8,17.8,0,0,0-6.439-7.369L94.587,136.193a5.894,5.894,0,0,0-5.576-.616h0a3.383,3.383,0,0,0-.545.317l-15.216,8.93a5.7,5.7,0,0,1,5.91.439l69.955,40.456a18.118,18.118,0,0,1,6.6,7.705h0Z",
    transform: "translate(-70.174 3.36)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8380",
    "data-name": "Path 8380",
    d: "M122.712,259.481a7.823,7.823,0,0,1-2.9,7.036l15.11-8.8h0c1.969-1.055,3.219-3.624,3.219-7.3V172.64a22,22,0,0,0-2.5-9.71l-15.274,9.4h0a21.969,21.969,0,0,1,2.35,9.376Z",
    transform: "translate(-34.833 24.45)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8381",
    "data-name": "Path 8381",
    d: "M129.914,204.243c0,10.079-3.995,13.51-9.973,10.044a14.071,14.071,0,0,1-6.683-8.8c-1.76,2.164-4.486,2.305-8.321.087A25.179,25.179,0,0,1,93.679,184.84c0-8.427,4.907-11.329,11.258-7.67a19.349,19.349,0,0,1,7.494,8.039v-3.328l6.631,3.835V203.94a5.278,5.278,0,0,0,2.35,4.935c2.235,1.3,3.607-.9,3.607-7.423,0-11.416-7.318-23.518-18.134-29.762s-18.118-1.9-18.118,9.851a36.938,36.938,0,0,0,17.925,30.836,20.9,20.9,0,0,0,9.6,3.055l1.549,6.084a25,25,0,0,1-11.169-3.675C92.6,209.7,83.3,193.3,83.3,178.455s9.4-20.228,23.57-12.032C120.576,174.322,129.914,190.134,129.914,204.243Zm-17.389-8.46a12.91,12.91,0,0,0-6.11-11.169c-3.525-2.059-6.032-.616-6.032,4.169a13,13,0,0,0,6.032,11.24c3.534,1.986,6.121.7,6.121-4.242Z",
    transform: "translate(-62.547 24.193)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    transform: "translate(20.752 186.784)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8382",
    "data-name": "Path 8382",
    d: "M129.914,204.243c0,10.079-3.995,13.51-9.973,10.044a14.071,14.071,0,0,1-6.683-8.8c-1.76,2.164-4.486,2.305-8.321.087A25.179,25.179,0,0,1,93.679,184.84c0-8.427,4.907-11.329,11.258-7.67a19.349,19.349,0,0,1,7.494,8.039v-3.328l6.631,3.835V203.94a5.278,5.278,0,0,0,2.35,4.935c2.235,1.3,3.607-.9,3.607-7.423,0-11.416-7.318-23.518-18.134-29.762s-18.118-1.9-18.118,9.851a36.938,36.938,0,0,0,17.925,30.836,20.9,20.9,0,0,0,9.6,3.055l1.549,6.084a25,25,0,0,1-11.169-3.675C92.6,209.7,83.3,193.3,83.3,178.455s9.4-20.228,23.57-12.032C120.576,174.322,129.914,190.134,129.914,204.243Zm-17.389-8.46a12.91,12.91,0,0,0-6.11-11.169c-3.525-2.059-6.032-.616-6.032,4.169a13,13,0,0,0,6.032,11.24c3.534,1.986,6.121.7,6.121-4.242Z",
    transform: "translate(-83.299 -162.591)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8383",
    "data-name": "Path 8383",
    d: "M165.875,255.431l-69.95-40.459a5.823,5.823,0,0,0-5.576-.6h0a3.375,3.375,0,0,0-.545.317l-15.216,8.93h.106a7.874,7.874,0,0,0-3.13,7.231v77.782c0,6.6,3.995,14.231,8.93,17.079l69.95,40.447a5.558,5.558,0,0,0,6.157.263l-.122.106,15.11-8.883h0c1.969-1.039,3.219-3.525,3.219-7.3V272.494C174.809,265.914,170.887,258.281,165.875,255.431Z",
    transform: "translate(-71.505 63.155)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8384",
    "data-name": "Path 8384",
    d: "M170.981,262.8a17.7,17.7,0,0,0-6.439-7.369L94.587,214.972a5.823,5.823,0,0,0-5.576-.6h0a3.375,3.375,0,0,0-.545.317l-15.216,8.93a5.682,5.682,0,0,1,5.91.423L149.115,264.5a18.063,18.063,0,0,1,6.6,7.722h0Z",
    transform: "translate(-70.174 63.156)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8385",
    "data-name": "Path 8385",
    d: "M122.712,338.242a8.107,8.107,0,0,1-2.9,7.125l15.11-8.883h0c1.969-1.039,3.219-3.525,3.219-7.3V251.4a21.934,21.934,0,0,0-2.5-9.691l-15.274,9.4h0a21.9,21.9,0,0,1,2.35,9.357Z",
    transform: "translate(-34.833 84.248)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8386",
    "data-name": "Path 8386",
    d: "M170.981,262.8a17.7,17.7,0,0,0-6.439-7.369L94.587,214.972a5.823,5.823,0,0,0-5.576-.6h0a3.375,3.375,0,0,0-.545.317l-15.216,8.93a5.682,5.682,0,0,1,5.91.423L149.115,264.5a18.063,18.063,0,0,1,6.6,7.722h0Z",
    transform: "translate(-70.174 63.156)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8387",
    "data-name": "Path 8387",
    d: "M122.712,338.242a8.107,8.107,0,0,1-2.9,7.125l15.11-8.883h0c1.969-1.039,3.219-3.525,3.219-7.3V251.4a21.934,21.934,0,0,0-2.5-9.691l-15.274,9.4h0a21.9,21.9,0,0,1,2.35,9.357Z",
    transform: "translate(-34.833 84.248)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8388",
    "data-name": "Path 8388",
    d: "M99.33,269.115l-16.87-27.4v37.129Z",
    transform: "translate(-63.182 84.245)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8389",
    "data-name": "Path 8389",
    d: "M100.96,265.2l16.835,29.139V257.27Z",
    transform: "translate(-49.14 96.054)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8390",
    "data-name": "Path 8390",
    d: "M83.91,241l17.326,28.145a1.108,1.108,0,0,1,.193.211.494.494,0,0,1,0,.212l5.153,8.373,4.361-2.059a1.215,1.215,0,0,1,.235-.193,1.319,1.319,0,0,1,.564-.176l17.589-8.251Z",
    transform: "translate(-62.082 83.707)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8391",
    "data-name": "Path 8391",
    d: "M111.843,265.35l-4.714,2.216a1.316,1.316,0,0,1-.58.122,1.41,1.41,0,0,1-1.215-.667l-5.153-8.373-16.919,9.78,45.539,26.3Z",
    transform: "translate(-62.575 97.099)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(19.278 324.707)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8392",
    "data-name": "Path 8392",
    d: "M99.33,269.115l-16.87-27.4v37.129Z",
    transform: "translate(-82.46 -240.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8393",
    "data-name": "Path 8393",
    d: "M100.96,265.2l16.835,29.139V257.27Z",
    transform: "translate(-68.418 -228.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8394",
    "data-name": "Path 8394",
    d: "M83.91,241l17.326,28.145a1.108,1.108,0,0,1,.193.211.494.494,0,0,1,0,.212l5.153,8.373,4.361-2.059a1.215,1.215,0,0,1,.235-.193,1.319,1.319,0,0,1,.564-.176l17.589-8.251Z",
    transform: "translate(-81.36 -241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8395",
    "data-name": "Path 8395",
    d: "M111.843,265.35l-4.714,2.216a1.316,1.316,0,0,1-.58.122,1.41,1.41,0,0,1-1.215-.667l-5.153-8.373-16.919,9.78,45.539,26.3Z",
    transform: "translate(-81.851 -227.606)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8396",
    "data-name": "Path 8396",
    d: "M165.878,97.911,95.928,57.452a5.823,5.823,0,0,0-5.576-.6h0a3.379,3.379,0,0,0-.545.317L74.591,66.1H74.7a7.856,7.856,0,0,0-3.137,7.214V151.1c0,6.58,3.995,14.231,8.93,17.079l69.957,40.456a5.558,5.558,0,0,0,6.157.263l-.122.087,15.11-8.8h0c1.969-1.039,3.219-3.525,3.219-7.3V114.92C174.812,108.342,170.89,100.688,165.878,97.911Z",
    transform: "translate(-71.508 -56.404)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8397",
    "data-name": "Path 8397",
    d: "M170.981,105.229a17.749,17.749,0,0,0-6.439-7.388L94.587,57.452a5.823,5.823,0,0,0-5.576-.6h0a3.379,3.379,0,0,0-.545.317L73.25,66.1a5.682,5.682,0,0,1,5.91.423l69.957,40.456a18.066,18.066,0,0,1,6.6,7.722h0Z",
    transform: "translate(-70.174 -56.404)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8398",
    "data-name": "Path 8398",
    d: "M122.712,180.624a7.823,7.823,0,0,1-2.9,7.036l15.11-8.8h0c1.969-1.039,3.219-3.525,3.219-7.3V93.851a21.934,21.934,0,0,0-2.5-9.691l-15.274,9.4h0a21.9,21.9,0,0,1,2.35,9.357Z",
    transform: "translate(-34.833 -35.338)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8399",
    "data-name": "Path 8399",
    d: "M170.981,105.229a17.749,17.749,0,0,0-6.439-7.388L94.587,57.452a5.823,5.823,0,0,0-5.576-.6h0a3.379,3.379,0,0,0-.545.317L73.25,66.1a5.682,5.682,0,0,1,5.91.423l69.957,40.456a18.066,18.066,0,0,1,6.6,7.722h0Z",
    transform: "translate(-70.174 -56.404)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8400",
    "data-name": "Path 8400",
    d: "M122.712,180.624a7.823,7.823,0,0,1-2.9,7.036l15.11-8.8h0c1.969-1.039,3.219-3.525,3.219-7.3V93.851a21.934,21.934,0,0,0-2.5-9.691l-15.274,9.4h0a21.9,21.9,0,0,1,2.35,9.357Z",
    transform: "translate(-34.833 -35.338)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8401",
    "data-name": "Path 8401",
    d: "M127.249,150.689c-2.691-4.432-5.4-8.8-8.091-13.263a6.9,6.9,0,0,0-4.23-3.525c-1.3-.263-2.6-.564-3.941-.94a2.427,2.427,0,0,1-1.144-.985,111.2,111.2,0,0,1-10.431-23.922,1.318,1.318,0,0,1,.141-1.074c.827-.827,1.76-1.584,2.6-2.322a4.622,4.622,0,0,0,.667-4.662c-1.3-4.7-2.55-9.4-3.851-14.071a7.705,7.705,0,0,0-5.031-5.84,14.231,14.231,0,0,0-8.619.317c-1.074.4-1.645,1.372-1.645,3.043.458,3.219.757,6.4,1.372,9.675a139.907,139.907,0,0,0,31.31,65.093,5.012,5.012,0,0,0,3.922,2.251,11.82,11.82,0,0,0,7.44-2.867C129.272,156.178,129.113,153.668,127.249,150.689Z",
    transform: "translate(-62.256 -38.823)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8402",
    "data-name": "Path 8402",
    d: "M113.7,117.125a37.364,37.364,0,0,0-4.1-14.494,42.83,42.83,0,0,0-6.594-9.684c-.686-.773-1.267-1.02-1.619-.439s0,1.41.667,2.164l.686.792a37.063,37.063,0,0,1,8.8,19.93,7.049,7.049,0,0,0,.157,1.6,4.274,4.274,0,0,0,1.039,1.6c.369.263.792,0,1.09,0C113.719,117.873,113.737,117.5,113.7,117.125Z",
    transform: "translate(-48.92 -29.243)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8403",
    "data-name": "Path 8403",
    d: "M99.529,99.128a14.863,14.863,0,0,1,3.816,8.8,5.593,5.593,0,0,0,.545,1.424c1.074.879,1.6.58,1.6-.529a19.349,19.349,0,0,0-4.935-11.28c-.667-.686-1.213-.9-1.53-.317a1.76,1.76,0,0,0,.5,1.906Z",
    transform: "translate(-50.684 -25.679)",
    fill: "#337acc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(21.421 40.743)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8404",
    "data-name": "Path 8404",
    d: "M127.249,150.689c-2.691-4.432-5.4-8.8-8.091-13.263a6.9,6.9,0,0,0-4.23-3.525c-1.3-.263-2.6-.564-3.941-.94a2.427,2.427,0,0,1-1.144-.985,111.2,111.2,0,0,1-10.431-23.922,1.318,1.318,0,0,1,.141-1.074c.827-.827,1.76-1.584,2.6-2.322a4.622,4.622,0,0,0,.667-4.662c-1.3-4.7-2.55-9.4-3.851-14.071a7.705,7.705,0,0,0-5.031-5.84,14.231,14.231,0,0,0-8.619.317c-1.074.4-1.645,1.372-1.645,3.043.458,3.219.757,6.4,1.372,9.675a139.907,139.907,0,0,0,31.31,65.093,5.012,5.012,0,0,0,3.922,2.251,11.82,11.82,0,0,0,7.44-2.867C129.272,156.178,129.113,153.668,127.249,150.689Z",
    transform: "translate(-83.677 -79.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8405",
    "data-name": "Path 8405",
    d: "M113.7,117.125a37.364,37.364,0,0,0-4.1-14.494,42.83,42.83,0,0,0-6.594-9.684c-.686-.773-1.267-1.02-1.619-.439s0,1.41.667,2.164l.686.792a37.063,37.063,0,0,1,8.8,19.93,7.049,7.049,0,0,0,.157,1.6,4.274,4.274,0,0,0,1.039,1.6c.369.263.792,0,1.09,0C113.719,117.873,113.737,117.5,113.7,117.125Z",
    transform: "translate(-70.341 -69.988)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8406",
    "data-name": "Path 8406",
    d: "M99.529,99.128a14.863,14.863,0,0,1,3.816,8.8,5.593,5.593,0,0,0,.545,1.424c1.074.879,1.6.58,1.6-.529a19.349,19.349,0,0,0-4.935-11.28c-.667-.686-1.213-.9-1.53-.317a1.76,1.76,0,0,0,.5,1.906Z",
    transform: "translate(-72.105 -66.424)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-41",
    transform: "translate(531.243 61.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8407",
    "data-name": "Path 8407",
    d: "M332.495,57.369l16.482,9.376v-8.46h0c.6-7.722,6.455-10.694,13.6-6.561a26.629,26.629,0,0,1,8.126,7.792c1.6-10.553,10.168-14.283,20.527-8.321,11.515,6.648,20.827,22.867,20.827,36.095V99.78a5.7,5.7,0,0,0,2.761,4.977l9.71,5.682a14.071,14.071,0,0,1,6.895,12.067,5.753,5.753,0,0,1-8.636,4.977L332.739,75.435a15.831,15.831,0,0,1-7.879-13.629,5.1,5.1,0,0,1,7.635-4.432Z",
    transform: "translate(-324.86 -48.355)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8408",
    "data-name": "Path 8408",
    d: "M403.021,54.9l11.985,6.878V55.625h0c.439-5.612,4.7-7.776,9.886-4.768a19.347,19.347,0,0,1,5.91,5.64c1.175-7.635,7.4-10.4,14.934-6.051A33.491,33.491,0,0,1,460.881,76.69v9.094a4.115,4.115,0,0,0,2.04,3.525l7.036,4.133a10.166,10.166,0,0,1,5.012,8.8,4.185,4.185,0,0,1-6.208,3.659L403.2,68.042a11.451,11.451,0,0,1-5.717-9.9,3.711,3.711,0,0,1,5.541-3.236Z",
    transform: "translate(-269.741 -48.334)",
    fill: "#e6e6e6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageSolutions2New);
export default __webpack_public_path__ + "static/media/Landing-page-solutions-2-new.1b4dead8a89aa070f00d9847b4e8111f.svg";
export { ForwardRef as ReactComponent };